export default __webpack_public_path__ + "static/media/tomcrews.88628f1b.svg";